import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, of, timer } from 'rxjs';
import { ShopService } from 'src/app/shared/api/shop.service';
import { CartService } from 'src/app/shared/services/cart.service';
import { environment } from 'src/environments/environment';

import SHA1 from 'crypto-js/sha1';
import AES from "crypto-js/aes";
import CryptoJS from "crypto-js";
import { catchError, map } from 'rxjs/operators';
import { diff_minutes } from 'src/app/shared/helpers/formatDate';
import { ERROR_GIACENZA_CODE, handleGiacenzaError } from 'src/app/shared/helpers/giacenza_error_handler';
import { Documento } from 'src/app/shared/interfaces/custom/documento';
import { AnalyticsService } from 'src/app/shared/services/analytics.service.';
import { StoreService } from 'src/app/shared/services/store.service';

declare function Stripe(v, params?);

const secret_key = 'temp_9';
const pass = 'authce9d77b308c149d5992a80073633e4d5';

// numreg of documento is needed for google_analytics, facbook pixel
// numreg is created from server so need to save in local storage
// since document is created by payment intent
// and we cannot twice create same intent
let _serverDoc;

function encryptCurrentOrder(order, serverDoc) {
  _serverDoc = serverDoc;
  let json = JSON.stringify(order);
  let hash = SHA1(json).toString();
  let payload = JSON.stringify({
    hash: hash,
    time: new Date(),
    serverDoc: serverDoc
  });

  let encrypted = AES.encrypt(payload, pass);
  localStorage.setItem(secret_key, encrypted.toString());
}

function updateCurrentOrder(order) {
  let encrypted = localStorage.getItem(secret_key);
  let decrypted = AES.decrypt(encrypted, pass).toString(CryptoJS.enc.Utf8);
  let payload = JSON.parse(decrypted);

  payload.serverDoc = order;
  _serverDoc = order;

  let encrypted2 = AES.encrypt(JSON.stringify(payload), pass);
  localStorage.setItem(secret_key, encrypted2.toString());
}

function getCurrentOrder(order) {
  let json = JSON.stringify(order);
  let hash = SHA1(json).toString();
  try {
    let encrypted = localStorage.getItem(secret_key);
    if (!encrypted)
        return null;

    let decrypted = AES.decrypt(encrypted, pass).toString(CryptoJS.enc.Utf8);
    let payload = JSON.parse(decrypted);

    let time = new Date(payload.time);
    let diff = diff_minutes(new Date(), time);
    if (diff < 15 && payload.hash == hash) {
      _serverDoc = payload.serverDoc;
      return _serverDoc;
    }
    else {
      removeCurrentOrder();
      return null;
    }
  } catch(error) {
    console.error(error);
    return null;
  }
}

function removeCurrentOrder() {
  localStorage.removeItem(secret_key);
}

@Component({
  selector: 'app-pay-stripe',
  templateUrl: './pay-stripe.component.html',
  styleUrls: ['./pay-stripe.component.scss']
})
export class PayStripeComponent implements OnInit {
  documento : Documento;

  loading;
  btnDisabled;

  constructor(public modalRef: BsModalRef, private router : Router,
    private cart : CartService, private shop : ShopService, private analytics : AnalyticsService,
    private store : StoreService) {
      _serverDoc = undefined;
    }

  clientSecret;

  stripe;
  card;

  ngOnInit(): void {
    this.stripe = Stripe(environment.stripe, {
      stripeAccount: this.store.getStripeAccountID()
    });
    var elements = this.stripe.elements();

    var style = {
      base: {
        color: "black",
        fontSize: "16px",
        "::placeholder": {
          color: "gray"
        }
      },
      invalid: {
        fontFamily: 'Arial, sans-serif',
        color: "red",
        iconColor: "#fa755a"
      }
    };

    this.card = elements.create("card", {hidePostalCode: true, style: style });
    this.card.mount("#card-element");

    this.btnDisabled = true;
    let that = this;
    this.card.on("change", function (event) {
      if (event.error) {
        that.btnDisabled = true;
      }
      else if (!event.complete) {
        that.btnDisabled = true;
      }
      else {
        that.btnDisabled = false;
      }
      document.querySelector("#card-error").textContent = event.error ? event.error.message : "";
    });
  }

  getClientSecret() {
    let observable : Observable<string>;

    if (!this.clientSecret && !this.documento.payment_code) {
      try {
        let currentOrder = getCurrentOrder(this.documento);
        if (currentOrder) {
          this.documento = currentOrder;
        }
      } catch (err) {}
    }

    if (this.clientSecret) {
      observable = of(this.clientSecret);
    }
    else {
      if (this.documento.payment_code) {
        observable = this.shop.retrivePayment(this.documento.numreg, this.documento.payment_code).pipe(
          map<any, string>(r => {
            this.documento.payment_code = r.id;
            this.clientSecret = r.client_secret;

            if (_serverDoc) {
              try {
                updateCurrentOrder(this.documento);
              } catch (err) {}
            }
            return this.clientSecret;
        }),
        catchError(error => {
          this.loading = false;
          alert(JSON.stringify(error));
          return of(null);
        }));
      }
      else {
        observable = this.shop.getStripeIntent(this.documento).pipe(map(r => {
          this.clientSecret = r["payment_intent"]["client_secret"];
          try {
            encryptCurrentOrder(this.documento, r['documento']);
          } catch (err) {}
          return this.clientSecret;
        }),
        catchError(error => {
          this.loading = false;
          if (ERROR_GIACENZA_CODE.includes(error.error.error_code)) {
            this.modalRef.hide();
            handleGiacenzaError(this.router, this.cart, this.shop);
          } else
            alert(JSON.stringify(error));
          return of(null);
        }));
      }
    }
    
    return observable;
  }

  pay() {
    this.loading = true;

    this.getClientSecret().subscribe(_clientSecret => {
      if (_clientSecret) {
        this.stripe
        .confirmCardPayment(this.clientSecret, {
          payment_method: {
            card: this.card
          }
        })
        .then((result) => {
          if (result.error) {
            this.loading = false;
            this.showError(result.error.message);
          } else {
            let doc = this.documento;
            if (_serverDoc) {
              doc = _serverDoc;
            }
            try {
              this.analytics.onPurchaseEvent(doc);
            } catch (err) { console.error(err); }
            this.modalRef.hide();

            localStorage.setItem('lastOrder', JSON.stringify(doc));

            this.router.navigate(['shop/cart/checkout/success']);
            timer(0).subscribe(r => {
              removeCurrentOrder();
              this.cart.resetCart();
            })
          }
        });
      }
    });
  }

  showError(errorMsgText) {
    var errorMsg = document.querySelector("#card-error");
    errorMsg.textContent = errorMsgText;
  };

}
